(function ($, $h) {

    var $win = $(window);
    var $container;
    var $articles;
    var $moreListSpinner;
    var $footer;
    var _isLoading;
    var _fillEmptyArticle;
    var _magazineNo;
    var _isAuthor;
    var _isMore;
    var _nextUrl;
    var _lastArticlePublishTime = 0;

    var firstArticleLoad = true;
    var moveListHash = '#list';

    $h.registerHelper('math', function (lvalue, operator, rvalue, options) {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);

        return {
            '+': lvalue + rvalue,
            '-': lvalue - rvalue,
            '*': lvalue * rvalue,
            '/': lvalue / rvalue,
            '%': lvalue % rvalue
        }[operator];
    });

    $h.registerHelper('ifThird', function (index, options) {
        if (index % 3 == 0) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }

    });

    $h.registerHelper('times', function (n, block) {
        var accum = '';
        for (var i = 0; i < n; ++i)
            accum += block.fn(i);
        return accum;
    });

    var _init = function (magazineNo, isAuthor, fillEmptyArticle) {
        _magazineNo = magazineNo;
        _isAuthor = isAuthor;
        _fillEmptyArticle = fillEmptyArticle;

        $container = $('.magazine_articles');
        $footer = $('.magazine_footer');

        _initPositionRelationTag();

        _initSocialButton();

        if (B.Util.localStorage.get(B.localStorageKey.magazine.lastTime)) {
            _lastArticlePublishTime = B.Util.localStorage.get(B.localStorageKey.magazine.lastTime);
        }

        var hasLocalStorageListData = B.Util.localStorage.get(B.localStorageKey.magazine.listData);
        var beforeReferrer = B.Util.localStorage.get(B.localStorageKey.referrer);

        if (hasLocalStorageListData && B.Util.localStorage.get(B.localStorageKey.viewArticleUid) && beforeReferrer == location.href) {
            if (_lastArticlePublishTime > 0) {
                _isMore = true;
                _nextUrl = _makeNextUrlForLocalStorage(_lastArticlePublishTime);
                _initList();
                $moreListSpinner.show();
            } else {
                _initList();
            }

            $('.list_magazine').append(hasLocalStorageListData);
            B.Util.localStorage.remove(B.localStorageKey.viewArticleUid);
            _positionRelationTag();
        } else {
            _loadList(_nextUrl);
        }

        $container.on('click', '.magazine_article', _setClickArticleUid);
    };

    var _makeNextUrlForLocalStorage = function (lastTime) {
        return '/magazine/' + _magazineNo + '/articles?createTime=' + lastTime;
    };

    var _setClickArticleUid = function (e) {
        var $cTarget = $(e.currentTarget);
        var uId = $cTarget.data('articleuid');

        if (uId) {
            B.Util.localStorage.set(B.localStorageKey.magazine.clickArticleUid, uId);
        }
    };

    var _initSocialButton = function () {
        var btnFacebook = $('.btn_facebook');
        var btnKakaostory = $('.btn_kakaostory');
        var btnTwitter = $('.btn_tweeter');

        btnFacebook.on('mouseover', function (e) { $(this).addClass('over'); });
        btnKakaostory.on('mouseover', function (e) { $(this).addClass('over'); });
        btnTwitter.on('mouseover', function (e) { $(this).addClass('over'); });

        btnFacebook.on('mouseout', function (e) { $(this).removeClass('over'); });
        btnKakaostory.on('mouseout', function (e) { $(this).removeClass('over'); });
        btnTwitter.on('mouseout', function (e) { $(this).removeClass('over'); });
    };

    var _loadList = function (nextUrl) {
        if (_isLoading) {
            return;
        }

        _isLoading = true;

        var url = B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/articles';

        if (nextUrl != null && nextUrl.length > 20) {
            url = B.Config.apiUrl + '/v1/' +  nextUrl;
        }

        B.Util.ajax({
            url: url,
            method: 'GET',
            success: function (r) {
                if (nextUrl) {
                    $('.magazine_subscription').show();
                }

                if (r.data.moreList) {
                    B.Util.localStorage.set(B.localStorageKey.magazine.lastTime, r.data.lastCreateTime);
                } else {
                    B.Util.localStorage.remove(B.localStorageKey.magazine.lastTime);
                }

                _drawList(r.data);
                _positionRelationTag();
                _scrollMoveToArticleList();
            },
            error: function () {
                _errorMessage({
                    alertWrapTitle: '오류가 발생했습니다.'
                });
            },
            complete: function () {
                _isLoading = false;
                onScroll();
            }
        });
    };

    var _scrollMoveToArticleList = function () {
        if (location.hash == moveListHash && B.UserAgent.isMobile && firstArticleLoad) {
            $('html, body').animate({
                scrollTop: $(window).height()
            }, 500);
        }

        firstArticleLoad = false;
    };

    var _positionRelationTag = function () {
        var $relationTag = $('.relation_tag');

        if ($relationTag.length == 0) {
            return;
        }

        var bodyY = $win.height();
        var articlesY = $container.height();
        var relationTagsY = $relationTag.offset().top;

        if (bodyY - relationTagsY < 200) {
            $relationTag.css('position', 'relative');
        } else {
            $relationTag.css('position', 'absolute');
        }

        if (_isMore || relationTagsY - articlesY < 400) {
            $relationTag.css('position', 'relative');
        }
    };

    var _drawList = function (data) {
        var $view;
        var articles = data.list;
        _isMore = data.moreList;
        _nextUrl = data.nextUrl;

        if (!$articles) {
            if (!articles || articles.length == 0) {
                $footer.hide();

                if (!B.UserAgent.isMobile && _isAuthor) {
                    _errorMessage({
                        alertWrapTitle: '매거진에 발행된 글이 없습니다.',
                        alertWrapSubTitle: '매거진에 글을 담아보세요.',
                        alertWrapButtonLink: '/write?magazineNo=' + _magazineNo,
                        alertWrapButton: '글쓰기'
                    });
                } else {
                    _errorMessage({
                        alertWrapTitle: '매거진에 발행된 글이 없습니다.'
                    });
                }

                return;
            }

            _initList();
        }

        var emptyArticleCount = 0;

        if (_fillEmptyArticle && (3 - (articles.length % 3)) < 3) {
            emptyArticleCount = 3 - (articles.length % 3);
        }

        $view = $(B.Util.getTemplate('magazine-article-list.hbs', {
            articles: articles,
            emptyArticleCount: emptyArticleCount
        }));
        $articles.append($view);

        if (_isMore) {
            $moreListSpinner.show();
        } else {
            $moreListSpinner.hide();
        }

        B.Util.localStorage.set(B.localStorageKey.magazine.listData, $('.list_magazine')[0].innerHTML);
        B.Util.localStorage.set(B.localStorageKey.referrer, location.href);
    };

    var _initPositionRelationTag = function () {
        $win.resize(function () {
            _positionRelationTag();
        });
    };

    var _initList = function () {
        $container.html(B.Util.getTemplate('magazine-article.hbs'));
        $articles = $container.find('.list_magazine');
        $moreListSpinner = $container.find('.more_list');

        if (_isMore) {
            $win.on('scroll', onScroll);
        }
    };

    var _errorMessage = function (alert) {
        $container.html(B.Util.getTemplate('alert.hbs', alert));
    };

    var onScroll = function (e) {
        if (!_isMore || !$moreListSpinner || !$moreListSpinner.is(':visible')) {
            return;
        }

        var top = $moreListSpinner.offset().top;
        var appearTop = $win.scrollTop() + $win.height();

        if (appearTop > top) {
            _loadList(_nextUrl);
        }
    };

    B.Magazine.Article = {
        init: function (magazineNo, isAuthor, fillEmptyArticle) {
            _init(magazineNo, isAuthor, fillEmptyArticle);
        },
        hide: function () {
            _hide();
        }
    };

})(jQuery, Handlebars);
